import axios from "axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();

export const createEmployeeApi = async (
    url: string,
    employeeData: {
        EmployeeType: string;
        PermanentAddress: string;
        Salary: number;
        HourlyRate?: number | undefined; // Optional, can be null
        JoiningDate: string; // Use ISO string format for dates
        LeavingDate?: string | null; // Optional
        IsActive: boolean;
        UserId: string;
    }
) => {
    const token = cookies.get("authToken"); // Replace with your token retrieval logic

    try {   
        const response = await axios.post(
            `${url}/Employee/Create`, // Endpoint URL
            employeeData, // Request body
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json", // Specify JSON content type
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Failed to create employee:", error);
        throw error;
    }
};

export const getEmployeeByUserIdApi = async (url: string, userId: string) => {
    const token = cookies.get("authToken"); // Replace with your token retrieval logic

    try {
        const response = await axios.get(
            `${url}/Employee/GetByUserId/${userId}`, // Endpoint URL
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data; // Return the fetched employee data
    } catch (error) {
        console.error("Failed to fetch employee by user ID:", error);
        throw error;
    }
};

export const updateEmployeeApi = async (
    url: string,
    employeeData: {
        Id: string;
        EmployeeType: string;
        PermanentAddress: string;
        Salary: number;
        HourlyRate?: number | undefined; // Optional, can be null
        JoiningDate: string;
        LeavingDate?: string | null;
        IsActive: boolean;
    }
) => {
    const token = cookies.get("authToken"); // Replace with your token retrieval logic

    try {
        const response = await axios.put(
            `${url}/Employee/Update`, // Endpoint URL
            employeeData, // Request body
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json", // Specify JSON content type
                },
            }
        );
        return response.data; // Return the response data
    } catch (error) {
        console.error("Failed to update employee:", error);
        throw error;
    }
};

export const getAllEmployeesApi = async (
    url: string,
    page: number = 1,
    itemsPerPage: number = 10,
    searchTerm: string = "",
    selectedGender: number | null = null
) => {
    const token = cookies.get("authToken");
    const params = new URLSearchParams();

    // Add pagination parameters
    params.append("pageNumber", page.toString());
    params.append("pageSize", itemsPerPage.toString());
    params.append("searchTerm", searchTerm);
    if (selectedGender !== null) {
        params.append("gender", selectedGender.toString());
    }
    try {
        const response = await axios.get(
            `${url}/Employee/GetAll?${params.toString()}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data; // Return the paginated and filtered employees
    } catch (error) {
        console.error("Failed to fetch employees:", error);
        throw error;
    }
};